import api from './api';
import type {
  RevenueByStudio,
  RevenueBreakdownItem,
  RevenueTrend,
  VoucherStats,
} from '../types/revenue';

interface DateRangeParams {
  from: string;
  to: string;
}

export const revenueApi = {
  async getRevenueByStudio(params: DateRangeParams): Promise<RevenueByStudio[]> {
    const { data } = await api.get('/revenue/by-studio', { params });
    return data;
  },
  async getRevenueByProvince(params: DateRangeParams): Promise<RevenueBreakdownItem[]> {
    const { data } = await api.get('/revenue/by-province', { params });
    return data;
  },
  async getRevenueByDealType(params: DateRangeParams): Promise<RevenueBreakdownItem[]> {
    const { data } = await api.get('/revenue/by-deal-type', { params });
    // map dealType → name
    return data.map((r: any) => ({ name: r.dealType ?? r.name, totalRevenue: r.totalRevenue, orderCount: r.orderCount }));
  },
  async getRevenueByPaymentMethod(params: DateRangeParams): Promise<RevenueBreakdownItem[]> {
    const { data } = await api.get('/revenue/by-payment-method', { params });
    return data.map((r: any) => ({ name: r.paymentMethod ?? r.name, totalRevenue: r.totalRevenue, orderCount: r.orderCount }));
  },
  async getRevenueBySales(params: DateRangeParams): Promise<RevenueBreakdownItem[]> {
    const { data } = await api.get('/revenue/by-sales', { params });
    return data.map((r: any) => ({ name: r.salesName ?? r.name, totalRevenue: r.totalRevenue, orderCount: r.orderCount }));
  },
  async getRevenueByProductType(params: DateRangeParams): Promise<RevenueBreakdownItem[]> {
    const { data } = await api.get('/revenue/by-product-type', { params });
    return data;
  },
  async getVoucherStats(params: DateRangeParams): Promise<VoucherStats> {
    const { data } = await api.get('/revenue/voucher-stats', { params });
    return data;
  },
  async getRevenueTrend(params: DateRangeParams & { groupBy?: 'day' | 'week' | 'month' }): Promise<RevenueTrend[]> {
    const { data } = await api.get('/revenue/trend', { params });
    return data;
  },
};
